import { render, staticRenderFns } from "./SubjectTeachers.vue?vue&type=template&id=0c6aedc1&scoped=true"
import script from "./SubjectTeachers.vue?vue&type=script&lang=js"
export * from "./SubjectTeachers.vue?vue&type=script&lang=js"
import style0 from "./SubjectTeachers.vue?vue&type=style&index=0&id=0c6aedc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6aedc1",
  null
  
)

export default component.exports